module.exports = __webpack_public_path__ + "img/M1_frontal-maquetacion.e0cfe57d.jpg";